var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c("i", { staticClass: "fas fa-info" }),
          _vm._v(" " + _vm._s(_vm.$t("txtDetails")) + "\n    "),
          _vm.board.enableReadConfirmations
            ? [
                _c("i", {
                  staticClass: "fa fa-calendar-check c-pointer",
                  on: {
                    click: function($event) {
                      return _vm.$refs.readConfirmationsModal.open(_vm.card)
                    }
                  }
                }),
                _vm._v(" "),
                _c("CardReadConfirmationsModal", {
                  ref: "readConfirmationsModal",
                  attrs: { state: _vm.state }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", [
        _c("i", { staticClass: "far fa-check-square" }),
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t("txtCreated") +
                " " +
                _vm.formatDateTime(_vm.card.createdOn) +
                " - " +
                _vm.createdBy
            ) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("i", { staticClass: "far fa-calendar-alt" }),
        _vm._v("\n    " + _vm._s(_vm.$t("txtDueDate"))),
        _c("span", [_vm._v(" " + _vm._s(_vm.formatDateTime(_vm.card.dueDate)))])
      ]),
      _vm._v(" "),
      _vm.card.archived
        ? _c("div", [
            _c("i", { staticClass: "fa fa-archive" }),
            _vm._v("\n    " + _vm._s(_vm.$t("kanbanArchivedDate")) + "\n    "),
            _vm.card.archivedOn
              ? _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.formatDateTime(_vm.card.archivedOn) +
                          " - " +
                          _vm.archivedBy
                      )
                  )
                ])
              : _c("span", [_vm._v(" " + _vm._s(_vm.$t("kanbanUnknown")))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _c("i", { staticClass: "far fa-user" }),
        _vm._v("\n    " + _vm._s(_vm.$t("txtResponsibles"))),
        _c("span", [_vm._v(" " + _vm._s(_vm.responsible) + " ")])
      ]),
      _vm._v(" "),
      _vm.card.durations && _vm.card.durations.length
        ? _c(
            "div",
            [
              _c("i", { staticClass: "far fa-clock" }),
              _vm._v("\n    " + _vm._s(_vm.$t("kanbanDuration"))),
              _c("span", [_vm._v(" " + _vm._s(_vm.formattedDuration) + " ")]),
              _vm._v(" "),
              _vm.canShowDurationInfo
                ? _c("i", {
                    staticClass: "fa fa-info-circle c-pointer",
                    on: {
                      click: function($event) {
                        return _vm.$refs.durationInfoModal.open()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("DurationInfoModal", {
                ref: "durationInfoModal",
                attrs: { state: _vm.state, card: _vm.card }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("AttributeDisplay", {
        attrs: { state: _vm.state, board: _vm.board, card: _vm.card },
        on: {
          "open-system-attributes": function($event) {
            return _vm.$emit("open-system-attributes")
          }
        }
      }),
      _vm._v(" "),
      _c("VueFormIfSingularAttribute", {
        attrs: {
          state: _vm.state,
          board: _vm.board,
          flow: _vm.flow,
          card: _vm.card
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }